import * as React from "react";

import {cs}                     from "@Common/react/chain-services";
import {Link}                   from "@Common/react/cst2";
import {keyed1}                 from "@Common/react/keyed";
import {UseState}               from "@Common/react/use-state";
import {Responsive}             from "@Common/ui-components/responsive";
import {parseUrlQuery}          from "@Common/utils/parse-url-query";
import {AdvanceSearchDropdown}  from "./advance-search-dropdown/advance-search-dropdown";
import {AdvancedSearchModal}    from "./advanced-search-modal/advanced-search-modal";
import {OmniSearch}             from "./common/omni-search/omni-search";

export const SearchForm = ({next}:{
    next: Link<JSX.Element, {
        getValue    : () => {
            all        : any[],
            orderName ?: string,
            orderId   ?: string,
            cartId    ?: string,
            poNumber  ?: string,
            startDate ?: string,
            endDate   ?: string,
        },
        onClearAll  : () => void,
        renderInput : () => JSX.Element,
    }>,
}): JSX.Element => cs(
    ["queryParams", ({}, next) => next(parseUrlQuery(window.location.search))],
    ["tags", ({queryParams}, next) => UseState({
        next,
        initValue: {
            all: queryParams?.all ? [queryParams?.all] : [], //only searches order name and order id until SOLR search is implemented
            orderName: queryParams?.orderName ?? undefined,
            orderId: queryParams?.orderId ?? undefined,
            cartId: queryParams?.cartId ?? undefined,
            poNumber: queryParams?.poNumber ?? undefined,
            startDate: queryParams?.startDate ?? undefined,
            endDate: queryParams?.endDate ?? undefined,
        },
    })],
    ["freeText", (_, next) => UseState({next, initValue: "",})],
    ({tags, freeText,}) => next({
        getValue: () => tags.value,
        onClearAll: () => {
            tags.onChange({
                all: [],
                orderName: null,
                orderId: null,
                cartId: null,
                poNumber: null,
                startDate: null,
                endDate: null,
            });
            freeText.onChange("");
        },
        renderInput: () => cs(
            // @ts-ignore
            ["responsive", (_, next) => <Responsive {...{
                sizes: {
                    desktop: 1000,
                },
                next,
            }}/>],
            ({responsive}, next) => keyed1({key: responsive.ge("desktop"), next}),
            ({responsive}) => responsive.ge("desktop") ? cs(
                // For Desktop
                ["dropdown", (_, next) => AdvanceSearchDropdown({
                    tags, 
                    freeText,
                    next,
                })],
                ({dropdown}) => (
                    OmniSearch({
                        onAdvanceOpen: dropdown.showingExpand ? null : () => {
                            dropdown.showExpand();
                        },
                        tags,
                        freeText,
                        domRef: dropdown.domRef,
                    })
                ),
            ) : cs(
                // For Mobile
                ["modal", ({}, next) => (
                    AdvancedSearchModal({
                        tags,
                        freeText,
                        next,
                    })
                )],
                ({modal}) => (
                    OmniSearch({
                        onAdvanceOpen: modal.showing ? null : () => {
                            modal.show();
                        },
                        tags,
                        freeText,
                    })
                ),
            ),
        ),
    }),
);
